export const FORGET_PASSWORD = "FORGET_PASSWORD"
export const FORGET_PASSWORD_SUCCESS = "FORGET_PASSWORD_SUCCESS"
export const FORGET_PASSWORD_ERROR = "FORGET_PASSWORD_ERROR"
export const FORGET_PASSWORD_CLEAN = "FORGET_PASSWORD_CLEAN"
export const RESTORE_PASSWORD = "RESTORE_PASSWORD"
export const RESTORE_PASSWORD_SUCCESS = "RESTORE_PASSWORD_SUCCESS"
export const RESTORE_PASSWORD_ERROR = "RESTORE_PASSWORD_ERROR"